export const ENVIRONMENTS = [
  { key: "dev-int", label: "Dev-int", proxy: "https://test-ox-proxy.cf-acb.workers.dev/api" },
  { key: "qa",      label: "QA",      proxy: "https://qa-discovery-proxy-ox.cf-acb.workers.dev/api" },
  { key: "prod",    label: "Prod",    proxy: "https://prod-discovery-proxy-ox.cf-acb.workers.dev/api" },
  // New v2 backends, fronted by their own workers.
  { key: "dev-new", label: "Dev-new", proxy: "https://devint2-discovery-proxy-ox.cf-acb.workers.dev/api" },
  { key: "qa-new",  label: "QA-new",  proxy: "https://qa2-discovery-proxy-ox.cf-acb.workers.dev/api" },
];

export const ENV_STORAGE_KEY = "wissp_env_proxy";
